import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import styles from "./Dragon_Tiger/styles.module.css";

// Popups
import PlayerHistoryPopup from './Dragon_Tiger/PlayerHistoryPopup';
import CasinoResultsPopup from './Dragon_Tiger/CasinoResultsPopup';
import DragonTigerResultsPopup from './Dragon_Tiger/DragonTigerResultsPopup';
import Lucky7ResultsPopup from './Lucky7/Lucky7ResultsPopup';
import BollywoodResultsPopup from './Bollywood_Casino/BollywoodResultsPopup';

// Game Specific Results
import AndarBaharResult from './AndarBahar/Result';
import Card32Result from './Card32/Card32Result';
import DragonTigerLionResultPopup from './Dragon_Tiger_Lion/Dragon_Tiger_LionResultPopup';
import TeenPatiTtweentyResultPopup from './TeenPatiTtweenty/TeenPatiTtweentyResultPopup';
import TwocardResultPopup from './TwoCardTeenPati/TwocardResultPopup ';
import AAAResultsPopup from './Amar_Akbar_Anthony/AAAResultsPopup';
import BaccaratResultPopup from './Baccarat/BaccaratResultPopup';
import OneDayDragonTigerResultsPopup from './Day1DragonTiger/OneDayDragonTigerResultsPopup';
import Card32 from './Card32/Card32';
import { aaaresult, anderbhaerresult, baccaratresult, bollywoodresult, card32result, dragantigerSettlementResult, dtlresult, lucky7result, onedaydtresult, TwoCardTeenPattiResult, TwoTweentyTeenPattiResult } from '../../store/slices/casinoResultsSlice';
import { useDispatch, useSelector } from 'react-redux';



const FooterLinks = ({ socketData, gameType = '', settledData }) => {
    const dispatch = useDispatch();
    //api
    const DragantigerapiData = useSelector((state) => state.casinoResults.dragantigerSettlementResult);
    const BollywoodapiData = useSelector((state) => state.casinoResults.bollywood);
    const Lucky7apiData = useSelector((state) => state.casinoResults.lucky7);
    const AAAapiData = useSelector((state) => state.casinoResults.aaa);
    const DTLapiData = useSelector((state) => state.casinoResults.dtl);
    const TwocardapiData = useSelector((state) => state.casinoResults.TwoCardTeenPatti);
    const card32apiData = useSelector((state) => state.casinoResults.card32);
    const teenpatiapiData = useSelector((state) => state.casinoResults.TwoTweentyTeenPatti);
    const baccaratapiData = useSelector((state) => state.casinoResults.baccarat);
    const anderbhaerapiData   = useSelector((state) => state.casinoResults.anderbhaer);
    const odtapiData = useSelector((state) => state.casinoResults.onedaydt);









    useEffect(() => {
        if (gameType !== 'Dragon_Tiger' && gameType !== 'dragon_tiger') return;
        if ((socketData?.animationTime ?? 99) > 3) return;

        dispatch(dragantigerSettlementResult());

    }, [socketData?.animationTime, gameType, dispatch]);

    useEffect(() => {
        if (gameType !== 'Bollywood_Casino') return;

        if ((socketData?.animationTime ?? 99) > 3) return;

        dispatch(bollywoodresult());

    }, [socketData?.animationTime, gameType, dispatch]);

    useEffect(() => {
        if (gameType !== 'Lucky7') return;

        if ((socketData?.animationTime ?? 99) > 3) return;

        dispatch(lucky7result());

    }, [socketData?.animationTime, gameType, dispatch]);

    useEffect(() => {
        if (gameType !== 'AAA') return;

        if ((socketData?.animationTime ?? 99) > 3) return;

        dispatch(aaaresult());

    }, [socketData?.animationTime, gameType, dispatch]);

    useEffect(() => {
        if (gameType !== 'Dragon_Tiger_Lion') return;

        if ((socketData?.animationTime ?? 99) > 3) return;

        dispatch(dtlresult());

    }, [socketData?.animationTime, gameType, dispatch]);

    useEffect(() => {
        if (gameType !== 'TwoCardTeenPati') return;

        if ((socketData?.animationTime ?? 99) > 3) return;

        dispatch(TwoCardTeenPattiResult());

    }, [socketData?.animationTime, gameType, dispatch]);

    useEffect(() => {
        if (gameType !== 'card32') return;

        if ((socketData?.animationTime ?? 99) > 3) return;

        dispatch(card32result());

    }, [socketData?.animationTime, gameType, dispatch]);

    useEffect(() => {
        if (gameType !== 'TeenPatiTtweenty') return;

        if ((socketData?.animationTime ?? 99) > 3) return;

        dispatch(TwoTweentyTeenPattiResult());

    }, [socketData?.animationTime, gameType, dispatch]);

    useEffect(() => {
        if (gameType !== 'Baccarat') return;

        if ((socketData?.animationTime ?? 99) > 3) return;

        dispatch(baccaratresult());

    }, [socketData?.animationTime, gameType, dispatch]);

     useEffect(() => {
        if (gameType !== 'andarbahar') return;

        if ((socketData?.animationTime ?? 99) > 3) return;

        dispatch(anderbhaerresult());

    }, [socketData?.animationTime, gameType, dispatch]);

     useEffect(() => {
        if (gameType !== 'One_Day_Dragon_Tiger') return;

        if ((socketData?.animationTime ?? 99) > 3) return;

        dispatch(onedaydtresult());

    }, [socketData?.animationTime, gameType, dispatch]);

    const [playerHistoryOpen, setPlayerHistoryOpen] = useState(false);
    const [casinoResultsOpen, setCasinoResultsOpen] = useState(false);
    const [dragonTigerResultsOpen, setDragonTigerResultsOpen] = useState(false);
    const [lucky7ResultOpen, setLucky7ResultOpen] = useState(false);
    const [bollywoodResultOpen, setBollywoodResultOpen] = useState(false);
    const [AAAResultOpen, setAAAResultOpen] = useState(false);
    const [BaccaratResultOpen, setBaccaratResultOpen] = useState(false);
    const [onedaydragonTigerResultOpen, setOnedaydragonTigerResultOpen] = useState(false);
    const [anderbaherResultopen, setAnderbaherResultopen] = useState(false);
    const [card32SelectedResult, setCard32SelectedResult] = useState(null);
    const resultTime = socketData?.settlement?.resultTime;
    const showNewDot =  resultTime === 1;
    const [selectedResult, setSelectedResult] = useState(null);
    const [roundHistory, setRoundHistory] = useState([]);

    // Card32 States
    const [card32Rounds, setCard32Rounds] = useState([]);
    const [card32ModalOpen, setCard32ModalOpen] = useState(false);
    const [card32ResultData, setCard32ResultData] = useState(null);
    const [dragonTigerLionOpen, setDragonTigerLionOpen] = useState(false);
    const [tptOpen, setTptOpen] = useState(false);
    const [twocardOpen, setTwocardOpen] = useState(false);

    const winnerDotLabel = (winnerType = '') =>
        winnerType.replace(/^PLAYER/, '');
    const handleHistoryClick = (result) => {
        setSelectedResult(result);

        if (gameType === 'Lucky7') {
            setLucky7ResultOpen(true);
        } else if (gameType === 'Bollywood_Casino') {
            setBollywoodResultOpen(true);
        } else if (gameType === 'Dragon_Tiger' || gameType === 'dragon_tiger') {
            setDragonTigerResultsOpen(true);
        }
        else if (gameType === 'Dragon_Tiger_Lion' || gameType === 'dragon_tiger_lion') {
            setDragonTigerLionOpen(true); // ← New Handler
        }
        else if (gameType === 'TeenPatiTtweenty' || gameType === 'TeenPatiTtweenty') {
            setTptOpen(true); // ← New Handler
        }
        else if (gameType === 'TwoCardTeenPati' || gameType === 'TwoCardTeenPati') {
            setTwocardOpen(true); // ← New Handler
        }
        else if (gameType === 'AAA' || gameType === 'AAA') {
            setAAAResultOpen(true); // ← New Handler
        }

        else if (gameType === 'card32') {
            setCard32SelectedResult(result);  // ← true ki jagah result
            setCard32ModalOpen(true);          // ← yeh line add karo
        }
        else if (gameType === 'Baccarat' || gameType === 'Baccarat') {
            setBaccaratResultOpen(true); // ← New Handler
        }
        else if (gameType === 'One_Day_Dragon_Tiger' || gameType === 'One_Day_Dragon_Tiger') {
            setOnedaydragonTigerResultOpen(true); // ← New Handler
        }
        else if (gameType === 'andarbahar' || gameType === 'andarbahar') {
            setAnderbaherResultopen(true); // ← New Handler
        }
    };
    useEffect(() => {
        if (
            (gameType === 'Dragon_Tiger' || gameType === 'dragon_tiger') &&
            DragantigerapiData?.length
        ) {
            const formattedData = DragantigerapiData.map(item => ({
                roundId: item.roundId,
                winner: item.winner,
                dragonCard: item.dragonCard,
                tigerCard: item.tigerCard,
                pair: item.pair,
                outcome: item.winner || '',
                _raw: item
            })).slice(0, 10);

            setRoundHistory(formattedData);
        }
    }, [DragantigerapiData, gameType]);

useEffect(() => {
    if (
        gameType === 'Bollywood_Casino' &&
        BollywoodapiData?.length
    ) {
        const formattedData = BollywoodapiData
            .map(item => ({
                roundId: item.roundId,
                winner: String(item.winner || ''),
                drawnCard: item.drawnCard || null,
                parity: item.parity || '',
                color: item.color || '',
                settledAt: item.settledAt || '',
                _raw: item
            }))
            .slice(0, 10);

        setRoundHistory(formattedData);
    }
}, [BollywoodapiData, gameType]);

useEffect(() => {
    if (
        gameType === 'Lucky7' &&
        Lucky7apiData?.length
    ) {
        const formattedData = Lucky7apiData.map(item => ({
            roundId: item.roundId,
            winner: typeof item.winner === 'string' ? item.winner : '',
            drawnCard: item.drawnCard || null,
            parity: item.parity || '',
            color: item.color || '',
            settledAt: item.settledAt || '',
            _raw: item
        }))
            .slice(0, 10);

        setRoundHistory(formattedData);
    }
}, [Lucky7apiData, gameType]);

    useEffect(() => {
        if (gameType !== 'AAA' || !AAAapiData?.length) return;

        const formattedData = AAAapiData.map(item => ({
            roundId: item.roundId,
            winner: item.group || '',
            drawnCard: item.drawnCard || null,
            parity: item.parity || '',
            color: item.color || '',
            _raw: item
        })).slice(0, 10);

        setRoundHistory(formattedData);
    }, [AAAapiData, gameType]);

  useEffect(() => {
    if (gameType !== 'Dragon_Tiger_Lion' || !DTLapiData?.length) return;

    const formattedData = DTLapiData.map(item => {
        const winnerRaw = item.winner;

        return {
            roundId: item.roundId,
            winner: winnerRaw.toLowerCase(),
            tigerCard: item.tigerCard || '',
            lionCard: item.lionCard || '',
            dragonCard: item.dragonCard || '',
            dragonParity: item.dragonParity || '',
            tigerParity: item.tigerParity || '',
            lionParity: item.lionParity || '',
            dragonColor: item.dragonColor || '',
            tigerColor: item.tigerColor || '',
            lionColor: item.lionColor || '',
            dragonRank: item.dragonRank || '',
            tigerRank: item.tigerRank || '',
            lionRank: item.lionRank || '',
            settledAt: item.settledAt || '',
            _raw: item
        };
    }).slice(0, 10);

    setRoundHistory(formattedData);
}, [DTLapiData, gameType]);

    useEffect(() => {
        if (gameType !== 'TwoCardTeenPati' || !TwocardapiData?.length) return;

        const formattedData = TwocardapiData.map(item => {
            return {
                roundId: item.roundId,
             winner: item.winner?.toLowerCase() || '', 
                player1Hand: item.player1Hand || '',
                player2Hand: item.player2Hand || '',
                settledAt: item.settledAt || '',
                _raw: item
            };
        }).slice(0, 10);

        setRoundHistory(formattedData);
    }, [TwocardapiData, gameType]);


    useEffect(() => {
        if (gameType !== 'card32' || !card32apiData?.length) return;

        const formattedData = card32apiData.map(item => {
            return {
                roundId: item.roundId,
                winner: item.winner || '',
                player1Hand: item.player1Hand || '',
                player2Hand: item.player2Hand || '',
                player3Hand: item.player3Hand || '',
                player4Hand: item.player4Hand || '',
                player8Parity: item.player8Parity || '',
                player9Parity: item.player9Parity || '',
                player10Parity: item.player10Parity || '',
                player11Parity: item.player11Parity || '',
                rank: item.rank || null,
                suit: item.suit || null,
                settledAt: item.settledAt || '',
                _raw: item
            };
        }).slice(0, 10);

        setRoundHistory(formattedData);
    }, [card32apiData, gameType]);
    

    useEffect(() => {
        if (gameType !== 'TeenPatiTtweenty' || !teenpatiapiData?.length) return;

        const formattedData = teenpatiapiData.map(item => {
            return {
                roundId: item.roundId,
                winner: item.winner || '',
                player1Hand: item.player1Hand || '',
                player2Hand: item.player2Hand || '',
                settledAt: item.settledAt || '',
                _raw: item
            };
        }).slice(0, 10);

        setRoundHistory(formattedData);
    }, [teenpatiapiData, gameType]);
useEffect(() => {
    if (gameType !== 'Baccarat' || !baccaratapiData?.length) return;

    const formattedData = baccaratapiData.map(item => {
        return {
            roundId: item.roundId,
            winner: item.winner || '',
            playerACards: item.playerACards || '',
            playerBCards: item.playerBCards || '',
            playerAValue: item.playerAValue ?? 0,
            playerBValue: item.playerBValue ?? 0,
            highCard: item.highCard || '',
            lucky9: item.lucky9 || false,
            pairA: item.pairA || false,
            pairB: item.pairB || false,
            trioA: item.trioA || false,
            trioB: item.trioB || false,
            colorPlusA: item.colorPlusA || null,
            colorPlusB: item.colorPlusB || null,
            settledAt: item.settledAt || '',
            _raw: item
        };
    }).slice(0, 10);

    setRoundHistory(formattedData);
}, [baccaratapiData, gameType]);

useEffect(() => {
    if (gameType !== 'andarbahar' || !anderbhaerapiData?.length) return;

    const formattedData = anderbhaerapiData.map(item => {
        return {
            roundId:     item.roundId,
            winner:      item.winner || '',
            andarCards:  item.andarCards || '',
            baharCards:  item.baharCards || '',
            middleCard:  item.middleCard || '',   
            cardCode:    item.cardCode || '',
            rank:        item.rank || '',
            suit:        item.suit || '',
            parity:      item.parity || '',       
            settledAt:   item.settledAt || '',
            _raw:        item
        };
    }).slice(0, 10);

    setRoundHistory(formattedData);
}, [anderbhaerapiData, gameType]); 

useEffect(() => {
    if (gameType !== 'One_Day_Dragon_Tiger' || !odtapiData?.length) return;

    const formattedData = odtapiData.map(item => {
        return {
            roundId:      item.roundId,
            winner:       item.winner       || '',
            dragonCard:   item.dragonCard   || '',
            dragonColor:  item.dragonColor  || '',
            dragonParity: item.dragonParity || '',
            dragonSuit:   item.dragonSuit   || '',
            tigerCard:    item.tigerCard    || '',
            tigerColor:   item.tigerColor   || '',
            tigerParity:  item.tigerParity  || '',
            tigerSuit:    item.tigerSuit    || '',
            settledAt:    item.settledAt    || '',
            _raw:         item
        };
    }).slice(0, 10);

    setRoundHistory(formattedData);
}, [odtapiData, gameType]); 








    useEffect(() => {
        if (!settledData) return;

        const data = settledData?.data || settledData;
        if (!data?.roundId && !data?.id && !data?.gameId) return;

        if (
            (gameType === 'Dragon_Tiger' || gameType === 'dragon_tiger') &&
            !showNewDot
        ) return;
        else if (
            (gameType === 'Bollywood_Casino' || gameType === 'Bollywood_Casino') &&
            !showNewDot
        ) return;
         else if (
            (gameType === 'Dragon_Tiger_Lion' || gameType === 'Dragon_Tiger_Lion') &&
            !showNewDot
        ) return;

         else if (
            (gameType === 'TwoCardTeenPati' || gameType === 'TwoCardTeenPati') &&
            !showNewDot
        ) return;

         else if (
            (gameType === 'TeenPatiTtweenty' || gameType === 'TeenPatiTtweenty') &&
            !showNewDot
        ) return;

         else if (
            (gameType === 'AAA' || gameType === 'AAA') &&
            !showNewDot
        ) return;

           else if (
            (gameType === 'Lucky7' || gameType === 'Lucky7') &&
            !showNewDot
        ) return;

         else if (
            (gameType === 'card32' || gameType === 'card32') &&
            !showNewDot
        ) return;

         else if (
            (gameType === 'Baccarat' || gameType === 'Baccarat') &&
            !showNewDot
        ) return;

        else if (
            (gameType === 'andarbahar' || gameType === 'andarbahar') &&
            !showNewDot
        ) return;
        else if (
            (gameType === 'One_Day_Dragon_Tiger' || gameType === 'One_Day_Dragon_Tiger') &&
            !showNewDot
        ) return;

        

        const roundId = data.roundId || data.id || settledData?.gameId;

        const winningBets = data.winningBets || '';
        const winParts = winningBets ? winningBets.split(',').map(s => s.trim()) : [];
        const aaaWinner = winParts[winParts.length - 1] || '';

        let baccaratWinner = '';
        if (gameType === 'Baccarat') {
            baccaratWinner = data.winner || data.winningBets || '';
        }

        setRoundHistory(prev => {
            if (prev.some(r => r.roundId === roundId)) return prev;

            const newEntry = {
                roundId,
                matchTime: data.settledAt || new Date().toLocaleString('en-GB'),
                drawnCard: data.drawnCard || null,
                outcome: data.winningBets || data.outcome || '',
                winnerType: data.winnerType || '',
                winner: gameType === 'card32'
                    ? winnerDotLabel(data.winnerType || '')
                    : gameType === 'Baccarat'
                        ? baccaratWinner
                        : data.winner || socketData?.winner || (gameType === 'AAA' ? aaaWinner : ''),
                _raw: data,
            };

            return [newEntry, ...prev].slice(0, 10);
        });

    }, [settledData, gameType, socketData?.winner, showNewDot]);
    
const gameTypeToLabel = (type) => {
    const map = {
        'Dragon_Tiger': 'Dragon Tiger',
        'dragon_tiger': 'Dragon Tiger',
        'Dragon_Tiger_Lion': 'Dragon Tiger Lion',
        'dragon_tiger_lion': 'Dragon Tiger Lion',
        'Bollywood_Casino': 'Bollywood Casino',
        'Lucky7': 'Lucky7',
        'AAA': 'Amar Akbar Anthony',
        'TwoCardTeenPati': 'Two Card Teen Patti',
        'card32': 'Card32',
        'TeenPatiTtweenty': 'Tenn Patti T20',
        'Baccarat': 'Baccarat',
        'andarbahar': 'Andar Bahar',
        'One_Day_Dragon_Tiger': 'One Day Dragon Tiger',
    };
    return map[type] || ''; 
};

    return (
        <>
            {/* Footer Links */}
            <Box className={styles.FooterLinks_container}>
                <Box className={styles.FooterLinks_box}>
                    <Typography className={styles.FooterLinks_txt}>Last Result</Typography>
                    <Typography className={styles.FooterLinks_txt}>|</Typography>
                   <Box
    onClick={() =>
        window.location.href = `/casino-results?game=${encodeURIComponent(gameTypeToLabel(gameType))}`
    }
    sx={{ cursor: 'pointer' }}
>
    <Typography className={styles.FooterLinks_txt}>View All</Typography>
</Box>
                </Box>
            </Box>

            {/* Game History Section */}
            <Box className={styles.gameHistory_container}>



                {(gameType === 'Dragon_Tiger' || gameType === 'dragon_tiger') && (
                    roundHistory.length > 0 ? (
                        roundHistory.map((item) => {
                            const winner = String(item.winner || '').toUpperCase();
                            const label = winner === 'DRAGON' ? 'D' : winner === 'TIGER' ? 'T' : 'T';
                            return (
                                <Box
                                    key={item.roundId}
                                    className={styles.gameHistory_button_container}
                                    onClick={() => handleHistoryClick(item)}
                                    sx={{ cursor: 'pointer' }}
                                >
                                    <Typography
                                        className={
                                            winner === 'DRAGON' ? styles.dIndicator :
                                                winner === 'TIGER' ? styles.tIndicator :
                                                    styles.tIndicator
                                        }
                                    >
                                        {label}
                                    </Typography>
                                </Box>
                            );
                        })
                    ) : (
                        <Typography className={styles.FooterLinks_txt} style={{ opacity: 0.6 }}>
                            No results yet
                        </Typography>
                    )
                )}
                {/* Card32 */}
                {gameType === 'card32' && (
    roundHistory.length > 0 ? (
        roundHistory.map((item, index) => (
            <Box key={index} className={styles.gameHistory_button_container}
                onClick={() => handleHistoryClick(item)} sx={{ cursor: 'pointer', marginTop: '32px' }}>
                <Typography className={styles.card32Indicator}>
                    {item.winner?.toUpperCase().includes('TIE') ? 'T' : item.winner?.replace(/\D/g, '').trim()}
                </Typography>
            </Box>
        ))
    ) : (
        <Typography className={styles.FooterLinks_txt} style={{ opacity: 0.6 }}>No results yet</Typography>
    )
)}

                {/* Bollywood Casino */}
{/* Bollywood Casino */}
{gameType === 'Bollywood_Casino' &&
  (roundHistory.length > 0 ? (
    roundHistory.map((item, index) => {
      const w = String(item.winner || '').toUpperCase();

      const label = w.includes('DON')
        ? 'A'
        : w.includes('AMAR AKBAR')
        ? 'B'
        : w.includes('SAHIB')
        ? 'C'
        : w.includes('DHARAM')
        ? 'D'
        : w.includes('KIS KIS')
        ? 'E'
        : w.includes('GHULAM')
        ? 'F'
        : '?';

      return (
        <Box
          key={index}
          className={styles.gameHistory_button_container}
          onClick={() => handleHistoryClick(item)}
          sx={{ cursor: 'pointer', marginTop: '32px' }}
        >
          <Typography
            className={styles.dIndicator}
            sx={{ color: '#33c6ff' }}
          >
            {label}
          </Typography>
        </Box>
      );
    })
  ) : (
    <Typography className={styles.FooterLinks_txt} style={{ opacity: 0.6 }}>
      No results yet
    </Typography>
  ))}

                {gameType === 'Lucky7' && (
                    roundHistory.length > 0 ? (
                        roundHistory.map((item, index) => {
                          const w = String(item.winner || item.outcome || '').toLowerCase().trim();
                            const isTie = w === 'tie';
                            const isHigh = w === 'high' || w.includes('high');
                            const label = isTie ? 'T' : isHigh ? 'H' : 'L';
                            return (
                                <Box key={index} className={styles.gameHistory_button_container}
                                    onClick={() => handleHistoryClick(item)} sx={{ cursor: 'pointer' ,marginTop: '-20px !important',marginBottom: '10px !important' }}>
                                    <Typography className={isHigh ? styles.dIndicator : styles.tIndicator}>
                                        {label}
                                    </Typography>
                                </Box>
                            );
                        })
                    ) : (
                        <Typography className={styles.FooterLinks_txt} style={{ opacity: 0.6 }}>No results yet</Typography>
                    )
                )}

                {/* Andar Bahar */}
                {gameType === 'andarbahar'  && (
                    roundHistory.length > 0 ? (
                        roundHistory.map((item, index) => {
                            const w = String(item.winner || item._raw?.winningSide || item.winningSide || '').toLowerCase().trim();
                            const isAndar = w === 'andar';
                            return (
                                <Box key={index} className={styles.gameHistory_button_container}
                                    onClick={() => handleHistoryClick(item)} sx={{ cursor: 'pointer', marginBottom: '-8px' }}>
                                    <Typography className={isAndar ? styles.dIndicator : styles.tIndicator}>
                                        {isAndar ? 'A' : 'B'}
                                    </Typography>
                                </Box>
                            );
                        })
                    ) : (
                        <Typography className={styles.FooterLinks_txt} style={{ opacity: 0.6 }}>No results yet</Typography>
                    )
                )}

                {/* Dragon Tiger Lion */}
                {(gameType === 'Dragon_Tiger_Lion' || gameType === 'dragon_tiger_lion') && (
                    roundHistory.length > 0 ? (
                        roundHistory.map((item, index) => {
                            
                            const w = String(item.winner || '').toLowerCase().trim();
                            const label = w === 'dragon' ? 'D' : w === 'tiger' ? 'T' : w === 'lion' ? 'L' : "L";
                            return (
                                <Box key={index} className={styles.gameHistory_button_container}
                                    onClick={() => handleHistoryClick(item)} sx={{ cursor: 'pointer',marginBottom:'15px'}}>
                                    <Typography className={
                                        w === 'dragon' ? styles.dIndicator :
                                            w === 'tiger' ? styles.tIndicator :
                                                styles.tIndicator
                                    }>
                                        {label}
                                    </Typography>
                                </Box>
                            );
                        })
                    ) : (
                        <Typography className={styles.FooterLinks_txt} style={{ opacity: 0.6 }}>No results yet</Typography>
                    )
                )}

                {/* Teen Patti Twenty */}
                {gameType === 'TeenPatiTtweenty' &&  (
                    roundHistory.length > 0 ? (
                        roundHistory.map((item, index) => {
                            const winner = String(item.winner || '').toUpperCase().trim();

                            const isA = winner === 'PLAYER_A';
                            const isB = winner === 'PLAYER_B';

                            return (
                                <Box
                                    key={item.roundId || index}
                                    className={styles.gameHistory_button_container}
                                    onClick={() => handleHistoryClick(item)}
                                    sx={{ cursor: 'pointer' }}
                                >
                                    <Typography
                                        className={
                                            isA
                                                ? styles.dIndicator
                                                : isB
                                                    ? styles.tIndicator
                                                    : styles.tIndicator
                                        }
                                    >
                                        {isA ? 'A' : isB ? 'B' : 'T'}
                                    </Typography>
                                </Box>
                            );
                        })
                    ) : (
                        <Typography
                            className={styles.FooterLinks_txt}
                            style={{ opacity: 0.6 }}
                        >
                            No results yet
                        </Typography>
                    )
                )}

                {/* One Day Dragon Tiger */}
                {gameType === 'One_Day_Dragon_Tiger'  && (
                    roundHistory.length > 0 ? (
                        roundHistory.map((item, index) => {
                            const w = (item.outcome || item.winner || '').split(',')[0].trim().toLowerCase();
                            const isDragon = w === 'dragon';
                            const label = isDragon ? 'D' : 'T';
                            return (
                                <Box key={index} className={styles.gameHistory_button_container}
                                    onClick={() => handleHistoryClick(item)} sx={{ cursor: 'pointer' }}>
                                    <Typography className={isDragon ? styles.dIndicator : styles.tIndicator}>
                                        {label}
                                    </Typography>
                                </Box>
                            );
                        })
                    ) : (
                        <Typography className={styles.FooterLinks_txt} style={{ opacity: 0.6 }}>No results yet</Typography>
                    )
                )}

                {/* Baccarat */}
           {gameType === 'Baccarat' &&  (
    roundHistory.length > 0 ? (
        roundHistory.map((item, index) => {
            const w = String(item.winner || item._raw?.winner || item.outcome?.split(',')[0] || '').toUpperCase().trim();
            const label = w === 'PLAYER_A' || w === 'PLAYER' ? 'A' :
                          w === 'PLAYER_B' || w === 'BANKER' ? 'B' :
                          w === 'TIE' ? 'T' : '?';

            return (
                <Box
                    key={index}
                    className={styles.gameHistory_button_container}
                    onClick={() => handleHistoryClick(item)}
                    sx={{ cursor: 'pointer', marginBottom: '-20px' }}
                >
                    <Typography className={
                        label === 'A' ? styles.dIndicator :  
                        label === 'B' ? styles.tIndicator : 
                        label === 'T' ? styles.tIndicator :   
                        styles.tIndicator                    
                    }>
                        {label}
                    </Typography>
                </Box>
            );
        })
    ) : (
        <Typography className={styles.FooterLinks_txt} style={{ opacity: 0.6 }}>
            No results yet
        </Typography>
    )
)}

                {/* Two Card Teen Pati */}
{gameType === 'TwoCardTeenPati' && (
    roundHistory.length > 0 ? (
        roundHistory.map((item, index) => {
            const winner = String(item.winner || '').toUpperCase();
            const isPlayerA = winner === 'PLAYER_A';
            const isPlayerB = winner === 'PLAYER_B';
            const label = isPlayerB ? 'B' : 'A';

            return (
                <Box
                    key={item.roundId ?? index}
                    className={styles.gameHistory_button_container}
                    onClick={() => handleHistoryClick(item)}
                    sx={{ cursor: 'pointer' }}
                >
                    <Typography className={isPlayerA ? styles.dIndicator : styles.tIndicator}>
                        {label}
                    </Typography>
                </Box>
            );
        })
    ) : (
        <Typography className={styles.FooterLinks_txt} style={{ opacity: 0.6 }}>
            No results yet
        </Typography>
    )
)}

                {/* AAA */}
                {gameType === 'AAA' && (
                    roundHistory.length > 0 ? (
                        roundHistory.map((item, index) => {
                            const w = String(item.winner || '').toUpperCase();  // ab direct item.winner use karo
                            const label = w === 'AMAR' ? 'A' : w === 'AKBAR' ? 'B' : w === 'ANTHONY' ? 'C' : '?';
                            return (
                                <Box key={index} className={styles.gameHistory_button_container}
                                    onClick={() => handleHistoryClick(item)} sx={{ cursor: 'pointer', marginBottom:'-7px',marginTop:'-8px !important' }}>
                                    <Typography
                                        className={
                                            label === 'A' ? styles.dIndicator :
                                                label === 'B' ? styles.tIndicator :
                                                    styles.tIndicator
                                        }

                                    >
                                        {label}
                                    </Typography>
                                </Box>
                            );
                        })
                    ) : (
                        <Typography className={styles.FooterLinks_txt} style={{ opacity: 0.6 }}>No results yet</Typography>
                    )
                )}
            </Box>

            {/* Popups */}
           

            <DragonTigerResultsPopup
                open={dragonTigerResultsOpen}
                onClose={() => setDragonTigerResultsOpen(false)}
                resultData={selectedResult}
            />

            <Lucky7ResultsPopup
                open={lucky7ResultOpen}
                onClose={() => setLucky7ResultOpen(false)}
                resultData={selectedResult}
            />
            <Card32Result
                open={card32ModalOpen}
                onClose={() => {
                    setCard32ModalOpen(false);
                    setCard32SelectedResult(null);
                }}
                resultData={card32SelectedResult}
            />

            <BollywoodResultsPopup
                open={bollywoodResultOpen}
                onClose={() => setBollywoodResultOpen(false)}
                resultData={selectedResult}
            />
         <DragonTigerLionResultPopup
    open={dragonTigerLionOpen}
    onClose={() => setDragonTigerLionOpen(false)}
    resultData={selectedResult}
/>

            <TeenPatiTtweentyResultPopup
                open={tptOpen}
                onClose={() => setTptOpen(false)}
                resultData={selectedResult}
            />

            <TwocardResultPopup
                open={twocardOpen}
                onClose={() => setTwocardOpen(false)}
                resultData={selectedResult}
            />

            <AAAResultsPopup

                open={AAAResultOpen}
                onClose={() => setAAAResultOpen(false)}
                resultData={selectedResult}
            />

            <BaccaratResultPopup
                open={BaccaratResultOpen}
                onClose={() => setBaccaratResultOpen(false)}
                resultData={selectedResult}
            />

            <OneDayDragonTigerResultsPopup
                open={onedaydragonTigerResultOpen}
                onClose={() => setOnedaydragonTigerResultOpen(false)}
                resultData={selectedResult}

            />    <AndarBaharResult
                open={anderbaherResultopen}
                onClose={() => setAnderbaherResultopen(false)}
                resultData={selectedResult}
            />



            <PlayerHistoryPopup
                open={playerHistoryOpen}
                onClose={() => setPlayerHistoryOpen(false)}
            />
        </>
    );
};

export default FooterLinks;